import {Suspense} from 'react';
import {ConditionId, UserId} from '@legit.health/ui';
import {Container, Skeleton} from '@mui/material';
import BaseDiagnosticReportFormModal from '@/shared/components/diagnosticReport/DiagnosticReportFormModal';
import {FullScreenModalTitle} from '@/shared/components/ui/Modal';
import {UseModal} from '@/shared/hooks/useModal';
import ModalContent from './ModalContent';
import ModalTitle from './ModalTitle';

export default function DiagnosticReportFormModal({
  modal,
  ...rest
}: {
  patientId: UserId;
  modal: UseModal;
  conditionId?: ConditionId | null;
  onSuccess: () => void;
}) {
  return (
    <BaseDiagnosticReportFormModal
      modal={modal}
      title={
        <Suspense
          fallback={
            <FullScreenModalTitle>
              <Skeleton variant="rectangular" width="100px" height="20" />
            </FullScreenModalTitle>
          }
        >
          <ModalTitle patientId={rest.patientId} />
        </Suspense>
      }
    >
      <Suspense
        fallback={
          <Container maxWidth="xl">
            <Skeleton variant="rectangular" width="100%" height={100} sx={{mb: 8}} />
            <Skeleton variant="rectangular" width="100%" height={40} sx={{mb: 2}} />
            <Skeleton variant="rectangular" width="100%" height={80} sx={{mb: 4}} />
          </Container>
        }
      >
        <ModalContent {...rest} />
      </Suspense>
    </BaseDiagnosticReportFormModal>
  );
}
